import { Root, Indicator } from '@radix-ui/react-progress';
import cx from 'classnames';
import { useEffect, useRef, useState } from 'react';

interface CountdownProgressProps {
  duration: number;
  onComplete: () => void;
  trackClassName: string;
  barClassName: string;
}

const ToastProgressBar = ({ duration, onComplete, trackClassName, barClassName }: CountdownProgressProps) => {
  const [progress, setProgress] = useState(100);
  const timerRef = useRef<number>();

  useEffect(() => {
    if (duration <= 0) {
      setProgress(0);
      return onComplete();
    }

    timerRef.current = window.setInterval(() => {
      setProgress((prev) => Math.max(0, prev - 100 / duration));
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [duration, onComplete]);

  useEffect(() => {
    if (progress === 0) {
      clearInterval(timerRef.current);
      onComplete();
    }
  }, [progress, onComplete]);

  return (
    <Root value={progress} className={cx('absolute bottom-0 left-0 w-full h-[5px]', trackClassName)}>
      <Indicator
        className={cx('h-full transition-all duration-1000 ease-linear rounded', barClassName)}
        style={{ width: `${progress}%` }}
      />
    </Root>
  );
};

export default ToastProgressBar;
